import { useEffect, useState } from "react";

import { MarkdownNotes } from "@/components/cinch/MarkdownNotes/MarkdownNotes";

import { useUpsertNote } from "../api";

/**
 * Auto-saving markdown notes for a forecast week/scope. Owns the value +
 * persistence (debounces a save 800ms after the user stops typing) and delegates
 * the editing UX to the shared {@link MarkdownNotes} component.
 */
export function NotesArea({
  isoYear,
  isoWeek,
  scope,
  initialBody,
  label,
  placeholder,
  minHeightPx = 80,
}: {
  isoYear: number;
  isoWeek: number;
  scope: string;
  initialBody: string;
  label: string;
  placeholder?: string;
  minHeightPx?: number;
}) {
  const [body, setBody] = useState(initialBody);
  const mutation = useUpsertNote();

  useEffect(() => {
    setBody(initialBody);
  }, [initialBody]);

  useEffect(() => {
    if (body === initialBody) return;
    const t = setTimeout(() => {
      mutation.mutate({ iso_year: isoYear, iso_week: isoWeek, scope, body });
    }, 800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [body, initialBody, isoYear, isoWeek, scope]);

  return (
    <MarkdownNotes
      value={body}
      onChange={setBody}
      label={label}
      placeholder={placeholder}
      minHeightPx={minHeightPx}
      statusText={mutation.isPending ? "Saving…" : "Markdown"}
    />
  );
}
